<template>
  <div id="page" v-cloak>
    <nav class="trading_record_nav clear">
      <p v-for="(item,index) in type" :class="{ opt : (index+1) == present }" @click="navSelect((index+1),item.code)">{{item.value}}</p>
    </nav>
    <div>
      <p class="hint" v-if="present==1">每天14:00点统一分配，超过该时间捐赠的记录则自动列入次日计算。</p>
      <ul class="trading_record_class" v-if="present==2">
        <li style="width: 34%;">时间</li>
        <li style="width: 22%;">昵称</li>
        <li style="width: 22%;">邀请码</li>
        <li style="width: 22%;">数量</li>
      </ul>
      <mescroll-vue ref="mescroll" :class="{ mescroll_b : present == 2 }" :up="mescrollUp" @init="mescrollInit">
        <ul class="donation_record" v-if="present==1">
          <li class="clear" v-for="(item,index) in dataList">
            <p>{{item.date}}</p>
            <p>{{item.diamonds}}枚</p>
            <p class="money">
              <span>+ {{item.reward_money}}</span>
              <span>(约{{Math.floor(item.reward_money/item.diamonds * 1000) / 1000}}元/枚)</span>
            </p>
          </li>
        </ul>
        <ul class="giving_record" v-if="present==2">
          <li class="clear" v-for="(item,index) in dataList">
            <p style="width: 34%;">{{item.time}}</p>
            <p style="width: 22%;" class="name">{{item.taker_nick_name}}</p>
            <p style="width: 22%;">{{item.taker_cb_id}}</p>
            <p style="width: 22%;">{{item.give_diamonds}}枚</p>
          </li>
        </ul>
      </mescroll-vue>
      <div id="warpId"></div>
    </div>
  </div>
</template>

<script>
  import '../assets/style.css'
  import MescrollVue from 'mescroll.js/mescroll.vue'
  export default {
    name: 'DiamondDonationRecord',
    components: {
      MescrollVue // 注册mescroll组件
    },
    data() {
      return {
        userId: '',
        H5Key: '',
        md5: '',
        initData: {},
        type: [{
            'value': '捐赠记录',
            'code': 1
          },
          {
            'value': '赠送记录',
            'code': 2
          },
        ],
        present: 1,
        mescroll: null, // mescroll实例对象
        mescrollUp: { // 上拉加载的配置.
          callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
          htmlNodata: '<p class="upwarp-nodata">-- 已经到底了 --</p>',
          toTop: {
            //回到顶部按钮
            src: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-totop.png", //图片路径,默认null,支持网络图
            offset: 1000 //列表滚动1000px才显示回到顶部按钮
          },
          empty: {
            //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
            warpId: "warpId", //父布局的id (1.3.5版本支持传入dom元素)
            icon: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-empty.png", //图标,默认null,支持网络图
            tip: "暂无相关数据~" //提示
          }
        },
        dataList: [], // 列表数据
        minId: '',
      }
    },
    mounted() {
      if (window.LaiaJs) {
        window.LaiaJs.setTitle('钻石明细');
        this.userId = window.LaiaJs.getUserId();
        this.H5Key = window.LaiaJs.getH5Key();
        this.md5 = this.$md5(this.H5Key);
      } else {
        this.userId = '503a84e4f4374ec5916db6086bbe7b71';
        this.H5Key = 'UpSzXt4t5tSwTD2uYqVC1vPxVA1DWAWq';
        this.md5 = this.$md5(this.H5Key);
      }
    },
    methods: {
      // mescroll组件初始化的回调,可获取到mescroll对象
      mescrollInit(mescroll) {
        this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      },
      upCallback(page, mescroll) {
        if (page.num == 1) this.minId = "";
        //联网请求
        console.log(1);
        if (this.present == 1) {
          this.$axios.post("user/getDonateDiamondsRecord.do", {
            "user_id": this.userId,
            "sign": this.md5,
            "min_id": this.minId,
          }).then((res) => {
            // console.log(res);
            //请求的列表数据
            var list = res.data.recordList;
            // console.log(list)
            if (page.num == 1) this.dataList = [];
            //把请求到的数据添加到列表
            this.dataList = this.dataList.concat(list);
            this.minId = this.dataList[0] != undefined ? this.dataList[this.dataList.length - 1].id : '';
            //数据渲染成功后,隐藏下拉刷新的状态
            this.$nextTick(() => {
              this.mescroll.endSuccess(list.length);
            })
          }).catch((e) => {
            //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
            this.mescroll.endErr();
          })
        } else if (this.present == 2) {
          this.$axios.post("user/getGiveDiamondsRecord.do", {
            "user_id": this.userId,
            "sign": this.md5,
            "min_id": this.minId,
          }).then((res) => {
            // console.log(res);
            //请求的列表数据
            var list = res.data.recordList;
            // console.log(list)
            if (page.num == 1) this.dataList = [];
            //把请求到的数据添加到列表
            this.dataList = this.dataList.concat(list);
            this.minId = this.dataList[0] != undefined ? this.dataList[this.dataList.length - 1].id : '';
            //数据渲染成功后,隐藏下拉刷新的状态
            this.$nextTick(() => {
              this.mescroll.endSuccess(list.length);
            })
          }).catch((e) => {
            //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
            this.mescroll.endErr();
          })
        }
      },
      // 分类搜索
      navSelect(index, code) {
        if (index == this.present) {
          return;
        }
        this.present = index;
        this.dataList = [];
        this.mescroll.setPageNum(1);
        this.mescroll.triggerUpScroll();
      },
    }
  }
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }

  #page {
    width: 100%;
    height: 100vh;
    background-color: #eaf1f7;
  }
  .mescroll {
  	position: fixed;
  	width: 100%;
  	height: auto;
  	top: 3rem;
  	bottom: 0;
  }
  .mescroll_b {
  	position: fixed;
  	width: 100%;
  	height: auto;
  	top: 2.16rem;
  	bottom: 0;
  }
  .trading_record_nav {
    width: 100%;
    font-size: 0.4rem;
    text-align: center;
    font-weight: bold;
    color: #3672f9;
    border-bottom: 1px solid #dddfe4;
    background-color: #fff;
  }

  .trading_record_nav p {
    width: 50%;
    height: 1.2rem;
    line-height: 1.2rem;
    float: left;
  }

  .trading_record_nav .opt {
    color: #fff;
    background-color: #3672f9;
  }

  .trading_record_class {
    width: 100%;
    height: 0.94rem;
    line-height: 0.94rem;
    font-size: 0.38rem;
    text-align: center;
    color: #3e4854;
    background-color: #dee2ff;
  }

  .trading_record_class li {
    width: 25%;
    height: 0.94rem;
    line-height: 0.94rem;
    float: left;
  }

  .hint {
    padding: 0.3rem 0.45rem;
    font-size: 0.36rem;
    line-height: 0.6rem;
    color: #3870fa;
  }

  .donation_record,
  .giving_record {
    font-size: 0.36rem;
    background-color: #fff;
  }

  .donation_record li,
  .giving_record li {
    padding: 0 0.45rem;
    height: 1.38rem;
    line-height: 1.38rem;
    border-bottom: 1px solid #ecf0f7;
  }

  .donation_record li p {
    float: left;
    width: 33.33%;
    color: #3e4956;
    letter-spacing: 1px;
    text-align: center;
  }

  .donation_record li p:first-child {
    text-align: left;
  }

  .donation_record li p:last-child {
    text-align: right;
  }

  .donation_record li .money span {
    display: block;
    line-height: 0.5rem;
  }

  .donation_record li .money span:first-child {
    color: #3870FA;
    padding-top: 0.2rem;
  }
  .giving_record li {
    padding: 0;
  }
  .giving_record li p {
    float: left;
    width: 25%;
    font-size: 0.38rem;
    color: #3e4956;
    text-align: center;
  }
  .giving_record .name{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/pages/DiamondDonationRecord.vue